import React from "react";
import { AnnsModal, Col, FormInput, FormInputType, RadioButtonOptions } from "../../../../components/Component";
import { Form } from "reactstrap";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { useEffect } from "react";
import { addBranchAPI } from "./BranchTableData";
import { AppText, RadioOptionTypes, showErrorToast, showSuccessToast } from "../../../../utils";
const AddBranch = ({ visible, item, onSaved, onClosed }) => {
  const [branchData, setBranchData] = useState({});
  const [loading, setLoading] = useState(false);
  const [isDisable, setIsDisable] = useState(true);
  useEffect(() => {
    if ((branchData?.name?.length ?? 0) === 0) {
      setIsDisable(true);
    } else {
      setIsDisable(false);
    }
  }, [branchData]);
  useEffect(() => {
    if (visible) {
      if (item) {
        setBranchData({
          ...branchData,
          id: item?.id,
          name: item?.name,
          isActive: item?.isActive || false,
        });
      } else {
        setBranchData({
          ...branchData,
          name: "",
          isActive: true,
        });
      }
    }
  }, [visible, item]);
  const close = () => {
    onClosed();
    setLoading(false);
    setBranchData({});
  };
  const onFormSubmit = () => {
    if (isDisable) return;
    // Prevent multiple API calls if already loading
    if (loading) {
      return;
    }
    setLoading(true);
    addBranchAPI(branchData, (_, error) => {
      if (error === null) {
        let text =
          "Area Manager" + " " + branchData?.name + (item ? AppText.EditedSuccessfully : AppText.AddedSuccessfully);
        showSuccessToast(text);
        onSaved();
        close();
      } else {
        showErrorToast(error.message);
      }
      setLoading(false);
    });
  };
  const { errors, register, handleSubmit } = useForm();
  return (
    <>
      <AnnsModal
        size={"sm"}
        isOpen={visible}
        toggle={() => onClosed()}
        title={item ? "Edit Area Manager" : "Add Area Manager"}
        onClick={() => onFormSubmit()}
        disabled={isDisable}
        loading={loading}
      >
        <Form
          className="row gy-4 form-validation"
          onSubmit={(e) => {
            e.preventDefault();
            if (!loading) {
              handleSubmit(onFormSubmit)(e);
            }
          }}
        >
          <Col md="12">
            <div className="form-group">
              <div className="form-control-wrap">
                <FormInput
                  label={"Area Manager"}
                  type={FormInputType.default}
                  value={branchData?.name}
                  onTextChange={(text) => {
                    setBranchData((prev) => ({
                      ...prev,
                      name: text,
                    }));
                  }}
                />
              </div>
            </div>
          </Col>
          <Col md="12">
            <div className="form-group">
              <div className="form-control-wrap">
                <RadioButtonOptions
                  name="status"
                  optionType={RadioOptionTypes.status}
                  onChange={(index) => {
                    setBranchData((prev) => ({
                      ...prev,
                      isActive: index === 0,
                    }));
                  }}
                  activeIndex={branchData.isActive ? 0 : 1}
                />
              </div>
            </div>
          </Col>
        </Form>
      </AnnsModal>
    </>
  );
};
export default AddBranch;
